<script>
import List from '../../baseComponents/list'

export default {
	extends: List,
	data() {
		return {
			rowClick: (item) => {
				this.$router.push({ name: 'UserGroupDetail', params: { botId: item.bot, userGroupId: item._id } })
			},
			items: [
				{ header: 'Nom', value: (item) => item.name, sort: 'name', filter: { name: 'name'}},
				{ header: 'Nombre d\'utilisateurs', value: (item) => item.users.length, sort: false, filter: false },
				{ header: 'Contact', value: (item) => item.contact ? item.contact.firstName + ' ' + item.contact.lastName : '', sort: 'contact.firstName,contact.lastName', filter: { name: 'contact.firstName,contact.lastName', type: 'multiple' } },
				{ header: 'Email', value: (item) => item.contact ? item.contact.mail : '', sort: 'contact.mail', filter: { name: 'contact.mail'} },
				{ header: 'Telephone', value: (item) => item.contact ? item.contact.phone : '', sort: 'contact.phone', filter: { name: 'contact.phone'} }
			]
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/userGroups/userGroup.list.vue